import { api, tagTypes } from "./api";

export interface AddPartnerCategoryPayload {
  name: string;
  image_url: string;
  description: string;
}
export interface operational_hours {
  operational_hours: {
    monday: { is_open: boolean; open: string; close: string };
    tuesday: { is_open: boolean; open: string; close: string };
    wednesday: { is_open: boolean; open: string; close: string };
    thursday: { is_open: boolean; open: string; close: string };
    friday: { is_open: boolean; open: string; close: string };
    saturday: { is_open: boolean; open: string; close: string };
    sunday: { is_open: boolean; open: string; close: string };
  };
}

export interface AddPartnerOperHoursPayload {
  id: string;
  data: operational_hours;
}
export interface AddPartnerStatePayload {
  id: string;
  data: OperationalStatesPayload;
}

export interface OperationalStatesPayload {
  states: string;
  action: string;
}

export interface AddPartnerOperationalStateResponse {
  success: boolean;
  message: string;
  payload: OperationalStatesPayload;
}

export interface AddPartnerCategoryResponse {
  payload: any;
  message: string;
}

export interface UpdatePartnerCategoryPayload {
  name: string;
  image_url: string;
  description: string;
}

export interface UpdatePartnerCategoryParams {
  id: string;
  data: UpdatePartnerCategoryPayload;
}

export interface PartnerCategory {
  category_id: string;
  category_name: string;
  category_description?: string;
  category_image_url: string;
  count: number;
}

export interface AdminPartnerCategory {
  category_id: string;
  category_name: string;
  email: string;
  display_picture: string;
  country: string;
  occupation: string;
  role: string;
}

export interface Partner {
  _id: string;
  display_picture: string;
  business_name: string;
  email: string;
  phone: string;
  country: string;
  status: string;
  createdAt: string;
}

export interface PartnerCategoryDetails {
  category: {
    _id: string;
    name: string;
    description: string;
    image_url: string;
  };
  partners: Partner[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export interface CredentialField {
  key: string;
  value: string;
  is_secret: boolean;
  label: string;
}

export interface DeliveryPartnerCredential {
  _id: string;
  artisan_id: string;
  partner_name: string;
  credential_fields: CredentialField[];
  is_active: boolean;
  environment: string;
  deleted: boolean;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface DeliveryPartnerCredentialsDetails {
  credentials: DeliveryPartnerCredential[];
}

export interface CentralPartnerCategoryDetails {
  category: {
    _id: string;
    name: string;
    description: string;
    image_url: string;
  };
  outlets: Partner[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export interface GetAllPartnerCategoriesResponse {
  payload: {
    data: PartnerCategory[];
    total_categories: number;
  };
}


export interface TimelineEvent {
  event: string;
  label: string;
  occurred_at: string;
  triggered_by: string;
}

export interface BookingTimeline {
  timeline: TimelineEvent[];
}

export interface GetBookingTimelineResponse {
  payload: BookingTimeline;
}

export interface GetPartnerCategoryResponse {
  payload: PartnerCategoryDetails;
}

export interface GetDeliveryPartnerCategoryResponse {
  payload: DeliveryPartnerCredentialsDetails;
}

export interface CentralGetPartnerCategoryResponse {
  payload: CentralPartnerCategoryDetails;
}

export interface AddPartnerPayload {
  email: string;
  phone: string;
  partner_address: string;
  zip_code: string;
  years_of_operation: number;
  business_hours_open: string;
  business_hours_close: string;
  is_registered: boolean;
  is_owner: boolean;
  rc_number: string;
  city: string;
  state: string;
  country: string;
  contact_person: string;
  category_id: string;
  business_name: string;
  // Account manager information
  first_name: string;
  last_name: string;
  designation: string;
  account_manager_phone: string;
  gender: string;
  bio: string;
  // inhouse admin
  source_by: string;
  partnership_manager: string;
  can_deliver: boolean;
  // Location fields (optional)
  latitude?: string;
  longitude?: string;
  location?: string;
}

export interface CredentialField {
  key: string;
  value: string;
  is_secret: boolean;
  label: string;
}

export interface AddDeliveryPartnerPayload {
  environment: string;
  credential_fields: CredentialField[];
  id: string;
}

export interface AddCentralPartnerPayload {
  outlets: string[];
  adminId: string;
  email: string;
}

export interface SocialGalleryItem {
  image_url?: string;
  url?: string;
  category_name?: string;
  likes_count?: number;
  likers?: string[];
  file_size?: number;
  _id?: string;
}

export interface PartnerProfile {
  _id: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  gender?: string;
  suspended?: boolean;
  address?: {
    house_address?: string;
    city?: string;
    state?: string;
  };
  meta?: {
    bio?: string;
    other_services?: string[];
    languages_spoken?: string[];
    cover_photo_url?: string;
    profile_view_count?: number;
    audio_bio?: string;
    professional_year?: number;
    gallery?: SocialGalleryItem[];
    rating_logs?: any[];
    pending_verification?: boolean;
    paid_verification_fee?: boolean;
    socialGallery?: SocialGalleryItem[];
  };
  operational_hours?: {
    monday: { is_open: boolean; open: string; close: string };
    tuesday: { is_open: boolean; open: string; close: string };
    wednesday: { is_open: boolean; open: string; close: string };
    thursday: { is_open: boolean; open: string; close: string };
    friday: { is_open: boolean; open: string; close: string };
    saturday: { is_open: boolean; open: string; close: string };
    sunday: { is_open: boolean; open: string; close: string };
  };
  operational_states?: string[];
  status?: string;
  display_picture?: string;
  cover_photo_url?: string;
  country?: string;
  currency_symbol?: string;
  currency?: string;
  business_name?: string;
  designation?: string;
  vendor_type?: string;
  partner_info?: {
    partner_address?: string;
    city?: string;
    state?: string;
    zip_code?: string;
    bio?: string;
    years_of_operation?: number;
    business_hours_open?: string;
    business_hours_close?: string;
    is_registered?: boolean;
    can_deliver?: boolean;
    is_owner?: boolean;
    rc_number?: string;
    contact_person?: string;
    category_id?: string;
    category_name?: string;
    password_reset?: boolean;
  };

  phoneVersion?: string;
  account_manager?: {
    source_by?: string;
    partnership_manager?: string;
    account_manager_phone?: string;
  };
  createdAt?: string;
  updatedAt?: string;
  lastLogin?: string;
  referralCode?: string;
  service_fee?: {
    min?: number;
    max?: number;
  };
  wallet_balance?: {
    id?: number;
    artisan_uuid?: string;
    balance?: number;
    withdrawable_balance?: number;
    created_at?: string;
    updated_at?: string;
  };

  withdrawal_bank?: {
    account_name: string;
    account_number: string;
    artisan: string;
    bank_code: string;
    bank_name: string;
    bvn_number: string;
    __v: number;
    _id: string;
  };
  wallet_transaction?: Array<{
    type: "credit" | "debit";
    amount: number;
    transaction_details?: {
      credited_for?: string;
      debited_for?: string;
      customer?: {
        first_name?: string;
        last_name?: string;
      };
    };
    created_at: string;
  }>;
}

export interface AddPartnerResponse {
  payload: any;
  message: string;
}

export interface UploadPartnerLogoParams {
  id: string;
  image: File;
}

export interface UploadPartnerLogoResponse {
  payload: any;
  message: string;
}

export interface UploadPartnerGalleryImageParams {
  id: string;
  media: File[];
  is_cover: string;
  category_name: string;
}

export interface UploadPartnerGalleryImageResponse {
  payload: any;
  message: string;
}

export interface DeletePartnerGalleryImageParams {
  id: string;
  image_urls: string[];
}

export interface DeletePartnerGalleryImageResponse {
  payload: any;
  message: string;
}

export interface GetPartnerProfileResponse {
  payload: PartnerProfile;
}

export interface UpdatePartnerProfileParams {
  partnerId: string;
  formData: FormData;
}

export interface UpdatePartnerApiParams {
  partnerId: string;
  formData: {
    environment: string;
    credential_fields: CredentialField[];
  };
}

export interface RenameGalleryCategoryApiParams {
  partnerId: string;
  formData: {
    old_category_name: string;
    new_category_name: string;
  };
}

export interface UpdatePartnerProfileResponse {
  payload: any;
  message: string;
}

export interface CountryDetails {
  code: string;
  dialCode: string;
  flag: string;
  name: string;
  isoCode: string;
}


export interface GetCountryDetailsResponse {
  payload: {
    data: CountryDetails[];
  };
}

export interface StateDetails {
  isoCode: string;
  countryCode: string;
  latitude: string;
  longitude: string;
  name: string;
}


export interface GetStateDetailsResponse {
  payload: {
    data: StateDetails[];
  };
  country: {
      name: string,
      isoCode: string
    },
}

type GetPartnerCategoryByIdParams = {
  id?: string;
  page?: number;
  limit?: number;
};

type GetBookingTimlineById = {
  id?: string;
};

// Inject partner endpoints into the main API
export const partnerApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Get all partner categories
    getAllPartnerCategories: builder.query<
      GetAllPartnerCategoriesResponse,
      void
    >({
      query: () => ({
        url: "booking/v1/partner-category",
        method: "GET",
      }),
      providesTags: [tagTypes.PartnerCategory],
    }),
    // Get partner category by ID
    getPartnerCategoryById: builder.query<
      GetPartnerCategoryResponse,
      GetPartnerCategoryByIdParams
    >({
      query: ({ id, page = 1, limit = 10 }) => ({
        url: `booking/v1/partner-category/${id}`,
        method: "GET",
        params: { page, limit },
      }),
      providesTags: (result, error, { id }) => [
        { type: tagTypes.PartnerCategory, id },
      ],
    }),
    // Get partner category by ID
    getBookingTimeline: builder.query<
      GetBookingTimelineResponse,
      GetBookingTimlineById
    >({
      query: ({ id }) => ({
        url: `booking/v1/admin/history/${id}/timeline`,
        method: "GET",
      }),
      providesTags: (result, error, { id }) => [
        { type: tagTypes.PartnerCategory, id },
      ],
    }),
    // Get partner category by ID
    getDeliveryPartner: builder.query<
      GetDeliveryPartnerCategoryResponse,
      GetPartnerCategoryByIdParams
    >({
      query: ({ id }) => ({
        url: `artisan/v1/partner/api-credentials/${id}/full`,
        method: "GET",
      }),
      providesTags: (result, error, { id }) => [
        { type: tagTypes.PartnerCategory, id },
      ],
    }),
    // Get partner category by ID
    getCentralPartnerCategoryById: builder.query<
      CentralGetPartnerCategoryResponse,
      GetPartnerCategoryByIdParams
    >({
      query: ({ id, page = 1, limit = 10 }) => ({
        url: `artisan/v1//partner/group/${id}`,
        method: "GET",
        params: { page, limit },
      }),
      providesTags: (result, error, { id }) => [
        { type: tagTypes.PartnerCategory, id },
      ],
    }),

    // Add new partner category
    addPartnerCategory: builder.mutation<
      AddPartnerCategoryResponse,
      AddPartnerCategoryPayload
    >({
      query: (data) => ({
        url: "booking/v1/partner-category",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagTypes.PartnerCategory],
    }),

    // Add new partner category
    addOperatingHoursPartner: builder.mutation<
      AddPartnerCategoryResponse,
      AddPartnerOperHoursPayload
    >({
      query: ({ id, data }) => ({
        url: `artisan/v1/partners/${id}/operational_hours`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: [tagTypes.PartnerCategory],
    }),

    // Add new partner category
    addOperatingStatePartner: builder.mutation<
      AddPartnerOperationalStateResponse,
      AddPartnerStatePayload
    >({
      query: ({ id, data }) => ({
        url: `artisan/v1/partners/${id}/operational_states`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: [tagTypes.PartnerCategory],
    }),

    // Add new partner category
    removeCentralPartnerCategory: builder.mutation<any, any>({
      query: (data) => ({
        url: "artisan/v1//partner/group/remove",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagTypes.PartnerCategory],
    }),

    // Update partner category
    updatePartnerCategory: builder.mutation<
      AddPartnerCategoryResponse,
      UpdatePartnerCategoryParams
    >({
      query: ({ id, data }) => ({
        url: `booking/v1/partner-category/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: [tagTypes.PartnerCategory],
    }),
    // Delete partner category
    deletePartnerCategory: builder.mutation<any, string>({
      query: (id) => ({
        url: `booking/v1/partner-category/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [tagTypes.PartnerCategory],
    }),
    // Add new partner to category
    addPartner: builder.mutation<AddPartnerResponse, AddPartnerPayload>({
      query: (data) => ({
        url: "artisan/v1/partner/register",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagTypes.PartnerCategory],
    }),
    // Add new partner to category
    addDeliveryPartner: builder.mutation<
      AddPartnerResponse,
      AddDeliveryPartnerPayload
    >({
      query: ({ id, ...data }) => ({
        url: `artisan/v1/partner/api-credentials/${id}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagTypes.PartnerCategory],
    }),
    // Add new partner to category
    addCentralPartner: builder.mutation<
      AddPartnerResponse,
      AddCentralPartnerPayload
    >({
      query: (data) => ({
        url: "artisan/v1//partner/group/add",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagTypes.PartnerCategory],
    }),
    // Get partner profile by ID
    getPartnerProfile: builder.query<GetPartnerProfileResponse, string>({
      query: (partnerId) => ({
        url: `artisan/v1/partner/${partnerId}`,
        method: "GET",
      }),
      providesTags: (result, error, partnerId) => [
        { type: tagTypes.PartnerCategory, id: partnerId },
      ],
    }),
    // Get partner profile by ID
    getDeliveryPartnerProfile: builder.query<GetPartnerProfileResponse, string>(
      {
        query: (partnerId) => ({
          url: `artisan/v1/partner/api-credentials/${partnerId}/full`,
          method: "GET",
        }),
        providesTags: (result, error, partnerId) => [
          { type: tagTypes.PartnerCategory, id: partnerId },
        ],
      },
    ),
    // Upload partner profile logo
    uploadPartnerLogo: builder.mutation<
      UploadPartnerLogoResponse,
      UploadPartnerLogoParams
    >({
      query: ({ id, image }) => {
        const formData = new FormData();
        formData.append("image", image);
        formData.append("id", id);
        return {
          url: "artisan/v1/partner/profile/logo",
          method: "PUT",
          body: formData,
        };
      },
      invalidatesTags: [tagTypes.PartnerCategory],
    }),
    // Upload partner gallery image
    uploadPartnerGalleryImage: builder.mutation<
      UploadPartnerGalleryImageResponse,
      UploadPartnerGalleryImageParams
    >({
      query: ({ id, media, is_cover, category_name }) => {
        const formData = new FormData();
        // Append all media files separately
        media.forEach((file) => {
          formData.append("media", file);
        });
        formData.append("id", id);
        formData.append("is_cover", is_cover);
        formData.append("category_name", category_name);
        return {
          url: "artisan/v1/partner/gallery/upload",
          method: "PUT",
          body: formData,
        };
      },
      invalidatesTags: (result, error, { id }) => [
        { type: tagTypes.PartnerCategory, id },
      ],
    }),
    // Delete partner gallery image
    deletePartnerGalleryImage: builder.mutation<
      DeletePartnerGalleryImageResponse,
      DeletePartnerGalleryImageParams
    >({
      query: ({ id, image_urls }) => ({
        url: "artisan/v1/partner/profile/gallery",
        method: "DELETE",
        body: {
          id,
          image_urls,
        },
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: tagTypes.PartnerCategory, id },
      ],
    }),
    // Get country details
    getCountryDetails: builder.query<GetCountryDetailsResponse, void>({
      query: () => ({
        url: "booking/v1/country-list/details",
        method: "GET",
      }),
    }),
    // Get country details
    getCountry: builder.query<GetCountryDetailsResponse, void>({
      query: () => ({
        url: "artisan/v1/partner/countries",
        method: "GET",
      }),
    }),
    
    // Get country details
    getState: builder.query<GetStateDetailsResponse, string>({
      query: (countryCode) => ({
        url: `artisan/v1/partner/countries/${countryCode}`,
        method: "GET",
      }),
    }),
    // Update partner profile
    updatePartnerProfile: builder.mutation<
      UpdatePartnerProfileResponse,
      UpdatePartnerProfileParams
    >({
      query: ({ partnerId, formData }) => ({
        url: `artisan/v1/partner/profile`,
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: (result, error, { partnerId }) => [
        { type: tagTypes.PartnerCategory, id: partnerId },
      ],
    }),
    // Update partner profile
    updateDeliveryCredential: builder.mutation<
      UpdatePartnerProfileResponse,
      UpdatePartnerApiParams
    >({
      query: ({ partnerId, formData }) => ({
        url: `artisan/v1/partner/api-credentials/${partnerId}/partner`,
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: (result, error, { partnerId }) => [
        { type: tagTypes.PartnerCategory, id: partnerId },
      ],
    }),

    // Update partner profile
    renameGalleryCategory: builder.mutation<
      UpdatePartnerProfileResponse,
      RenameGalleryCategoryApiParams
    >({
      query: ({ partnerId, formData }) => ({
        url: `artisan/v1/partner/gallery/rename-category/${partnerId}`,
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: (result, error, { partnerId }) => [
        { type: tagTypes.PartnerCategory, id: partnerId },
      ],
    }),
    deleteDeliveryCredential: builder.mutation({
      query: (partnerId: string) => ({
        url: `/artisan/v1/partner/api-credentials/${partnerId}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetAllPartnerCategoriesQuery,
  useLazyGetAllPartnerCategoriesQuery,
  useGetPartnerCategoryByIdQuery,
  useLazyGetPartnerCategoryByIdQuery,
  useGetDeliveryPartnerQuery,
  useLazyGetDeliveryPartnerQuery,
  useGetCentralPartnerCategoryByIdQuery,
  useLazyGetCentralPartnerCategoryByIdQuery,
  useAddPartnerCategoryMutation,
  useAddOperatingHoursPartnerMutation,
  useRemoveCentralPartnerCategoryMutation,
  useUpdatePartnerCategoryMutation,
  useDeletePartnerCategoryMutation,
  useAddPartnerMutation,
  useAddDeliveryPartnerMutation,
  useAddCentralPartnerMutation,
  useGetPartnerProfileQuery,
  useLazyGetPartnerProfileQuery,
  useAddOperatingStatePartnerMutation,
  useUploadPartnerLogoMutation,
  useUploadPartnerGalleryImageMutation,
  useDeletePartnerGalleryImageMutation,
  useGetCountryDetailsQuery,
  useLazyGetCountryDetailsQuery,
  useGetStateQuery,
  useLazyGetStateQuery,
  useGetCountryQuery,
  useLazyGetCountryQuery,
  useUpdatePartnerProfileMutation,
  useUpdateDeliveryCredentialMutation,
  useRenameGalleryCategoryMutation,
  useDeleteDeliveryCredentialMutation,
  useGetBookingTimelineQuery,
  useLazyGetBookingTimelineQuery,
} = partnerApi;
